/* eslint-disable react/jsx-props-no-spreading */
import type { VoidFunctionComponent } from 'react';

import RefreshedRevisionDropdown from './Dropdown';
import type { RevisionDropdownProps } from './types';

import styles from './RevisionDropdown.module.less';

/**
 * Renders the revisions dropdown component based on the HYBRID_PROJECTS feature flag.
 */
const RevisionDropdown: VoidFunctionComponent<RevisionDropdownProps> = (props: RevisionDropdownProps) => {
  return (
    <div className={`nav-project-description ${styles.revisionDropdown}`}>
      <RefreshedRevisionDropdown {...props} />
    </div>
  );
};

export default RevisionDropdown;
